import React from 'react';
import styles from './BetLines.module.scss';
import ClosedBetLine from './BetLine/ClosedBetLine/ClosedBetLine';
import HomeTeamName from './BetLine/HomeTeamName/HomeTeamName';
import LiveBadge from '../../shared/LiveBadge/LiveBadge';
import MarketName from './BetLine/MarketName/MarketName';
import ProgramCode from './BetLine/ProgramCode/ProgramCode';
import Mbn from './BetLine/Mbn/Mbn';
import OddBadge from './BetLine/OddBadge/OddBadge';
import EventName from './BetLine/EventName/EventName';
import { EVENT_TYPE_ENUM } from '../../../constants/enums';

export default function PlacedBetLine({ bet }) {
    return (
        <div className={styles.bet}>
            <ClosedBetLine bet={bet} />
            <div className='flex'>
                <HomeTeamName name={bet.outcomeName} />
                <OddBadge bet={bet} />
            </div>
            <div className={'m-b-2'}>
                <MarketName name={bet.marketName} />
                <LiveBadge isLive={bet.producer === 'Live'} />
            </div>
            <Mbn mbn={bet.mbn} />
            {bet.eventType !== EVENT_TYPE_ENUM.outright && <ProgramCode programCode={bet.programCode} />}{' '}
            <EventName eventName={bet.eventName} teams={bet.teams} />
        </div>
    );
}
